import React from "react"
import '@/styles/polityka.css'

const Index = () => {
  return (
    <div class="calibre" id="calibre_link-0">
      <p class="block_" lang="pl">
        Polityka prywatności opisuje zasady przetwarzania przez nas informacji
        na Twój temat, w tym danych osobowych oraz ciasteczek, czyli tzw.
        cookies.
      </p>
      <p class="block_1"></p>
      <hr class="calibre1" />
      <p class="block_2">
        <span class="text_">1. Informacje ogólne</span>
      </p>
      <ol class="list_">
        <li class="block_3">
          <span lang="pl">
            Niniejsza polityka dotyczy Serwisu www, funkcjonującego pod adresem
            url:&nbsp;
          </span>
          <b lang="pl" class="calibre2">
            segments.pl
          </b>
        </li>
        <li class="block_3">
          <span lang="pl">
            Operatorem serwisu oraz Administratorem danych osobowych jest:
            Segments Jakub Duraj mała 6, 34-325 Łodygowice
          </span>
        </li>
        <li class="block_3">
          <span lang="pl">
            Adres kontaktowy poczty elektronicznej operatora:
            j.duraj@segments.pl
          </span>
        </li>
        <li class="block_3">
          <span lang="pl">
            Operator jest Administratorem Twoich danych osobowych w odniesieniu
            do danych podanych dobrowolnie w Serwisie.
          </span>
        </li>
        <li class="block_3">
          Serwis wykorzystuje dane osobowe w następujących celach:
        </li>
      </ol>
      <ul class="list_1">
        <li class="block_4">Prowadzenie newslettera</li>
        <li class="block_4">Prowadzenie systemu ogłoszeń drobnych</li>
        <li class="block_4">Wyświetlanie ogłoszeń użytkowników</li>
        <li class="block_4">Obsługa zapytań przez formularz</li>
        <li class="block_4">Przygotowanie, pakowanie, wysyłka towarów</li>
        <li class="block_4">Realizacja zamówionych usług</li>
        <li class="block_4">Prezentacja oferty lub informacji</li>
      </ul>
      <ol class="list_">
        <li value="6" class="block_3">
          Serwis realizuje funkcje pozyskiwania informacji o użytkownikach i ich
          zachowaniu w następujący sposób:
        </li>
      </ol>
      <ol class="list_">
        <li class="block_4">
          Poprzez dobrowolnie wprowadzone w formularzach dane, które zostają
          wprowadzone do systemów Operatora.
        </li>
        <li class="block_4">
          Poprzez zapisywanie w urządzeniach końcowych plików cookie (tzw.
          „ciasteczka”).
        </li>
      </ol>
      <p class="block_2">
        <span class="text_">
          2. Wybrane metody ochrony danych stosowane przez Operatora
        </span>
      </p>
      <ol class="list_">
        <li class="block_3">
          Miejsca logowania i wprowadzania danych osobowych są chronione w
          warstwie transmisji (certyfikat SSL). Dzięki temu dane osobowe i dane
          logowania, wprowadzone na stronie, zostają zaszyfrowane w komputerze
          użytkownika i mogą być odczytane jedynie na docelowym serwerze.
        </li>
        <li class="block_3">
          Dane osobowe przechowywane w bazie danych są zaszyfrowane w taki
          sposób, że jedynie posiadający Operator klucz może je odczytać. Dzięki
          temu dane są chronione na wypadek wykradzenia bazy danych z serwera.
        </li>
        <li class="block_3">
          Operator okresowo zmienia swoje hasła administracyjne.
        </li>
        <li class="block_3">
          W celu ochrony danych Operator regularnie wykonuje kopie
          bezpieczeństwa.
        </li>
        <li class="block_3">
          Istotnym elementem ochrony danych jest regularna aktualizacja
          wszelkiego oprogramowania, wykorzystywanego przez Operatora do
          przetwarzania danych osobowych, co w szczególności oznacza regularne
          aktualizacje komponentów programistycznych.
        </li>
      </ol>
      <p class="block_2">
        <span class="text_">3. Hosting</span>
      </p>
      <ol class="list_">
        <li class="block_3">
          Serwis jest hostowany (technicznie utrzymywany) na serwera operatora:
          domeny.pl
        </li>
        <li class="block_3">
          Dane rejestrowe firmy hostingowej: H88 S.A. z siedzibą w Poznaniu,
          Franklina Roosevelta 22, 60-829 Poznań, wpisana do Krajowego Rejestru
          Sądowego przez Sąd Rejonowy Poznań &ndash; Nowe Miasto i Wilda w
          Poznaniu, Wydział VIII Gospodarczy Krajowego Rejestru Sądowego pod nr
          KRS 0000612359, REGON 364261632, NIP 7822622168, kapitał zakładowy
          210.000,00 zł w pełni wpłacony.
        </li>
        <li class="block_3">
          <span class="text_1">Pod adresem&nbsp;</span>
          <a href="https://domeny.pl/" class="text_2">
            https://domeny.pl
          </a>
          <span class="text_1">
            &nbsp;możesz dowiedzieć się więcej o hostingu i sprawdzić politykę
            prywatności firmy hostingowej.
          </span>
        </li>
        <li class="block_3">Firma hostingowa:</li>
      </ol>
      <ul class="list_1">
        <li class="block_4">
          stosuje środki ochrony przed utratą danych (np. macierze dyskowe,
          regularne kopie bezpieczeństwa),
        </li>
        <li class="block_4">
          stosuje adekwatne środki ochrony miejsc przetwarzania na wypadek
          pożaru (np. specjalne systemy gaśnicze),
        </li>
        <li class="block_4">
          stosuje adekwatne środki ochrony systemów przetwarzania na wypadek
          nagłej awarii zasilania (np. podwójne tory zasilania, agregaty,
          systemy podtrzymania napięcia UPS),
        </li>
        <li class="block_4">
          stosuje środki fizycznej ochrony dostępu do miejsc przetwarzania
          danych (np. kontrola dostępu, monitoring),
        </li>
        <li class="block_4">
          stosuje środki zapewnienia odpowiednich warunków środowiskowych dla
          serwerów jako elementów systemu przetwarzania danych (np. kontrola
          warunków środowiskowych, specjalistyczne systemy klimatyzacji),
        </li>
        <li class="block_4">
          stosuje rozwiązania organizacyjne dla zapewnienia możliwie wysokiego
          stopnia ochrony i poufności (szkolenia, wewnętrzne regulaminy,
          polityki haseł itp.),
        </li>
        <li class="block_4">powołała Inspektora Ochrony Danych.</li>
      </ul>
      <ol class="list_">
        <li value="5" class="block_3">
          Firma hostingowa w celu zapewnienia niezawodności technicznej prowadzi
          logi na poziomie serwera. Zapisowi mogą podlegać:
        </li>
      </ol>
      <ul class="list_1">
        <li class="block_4">
          zasoby określone identyfikatorem URL (adresy żądanych zasobów &ndash;
          stron, plików),
        </li>
        <li class="block_4">czas nadejścia zapytania,</li>
        <li class="block_4">czas wysłania odpowiedzi,</li>
        <li class="block_4">
          nazwę stacji klienta &ndash; identyfikacja realizowana przez protokół
          HTTP,
        </li>
        <li class="block_4">
          informacje o błędach jakie nastąpiły przy realizacji transakcji HTTP,
        </li>
        <li class="block_4">
          adres URL strony poprzednio odwiedzanej przez użytkownika (referer
          link) &ndash; w przypadku gdy przejście do Serwisu nastąpiło przez
          odnośnik,
        </li>
        <li class="block_4">informacje o przeglądarce użytkownika,</li>
        <li class="block_4">informacje o adresie IP,</li>
        <li class="block_4">
          informacje diagnostyczne związane z procesem samodzielnego zamawiania
          usług poprzez rejestratory na stronie,
        </li>
        <li class="block_4">
          informacje związane z obsługą poczty elektronicznej kierowanej do
          Operatora oraz wysyłanej przez Operatora.
        </li>
      </ul>
      <p class="block_2">
        <span class="text_">
          4. Twoje prawa i dodatkowe informacje o sposobie wykorzystania danych
        </span>
      </p>
      <ol class="list_">
        <li class="block_3">
          W niektórych sytuacjach Administrator ma prawo przekazywać Twoje dane
          osobowe innym odbiorcom, jeśli będzie to niezbędne do wykonania
          zawartej z Tobą umowy lub do zrealizowania obowiązków ciążących na
          Administratorze. Dotyczy to takich grup odbiorców:
        </li>
      </ol>
      <ul class="list_1">
        <li class="block_4">operatorzy płatności</li>
        <li class="block_4">
          upoważnieni pracownicy i współpracownicy, którzy korzystają z danych w
          celu realizacji celu działania strony
        </li>
        <li class="block_4">
          firmy, świadczące usługi marketingu na rzecz Administratora
        </li>
      </ul>
      <ol class="list_">
        <li value="2" class="block_3">
          Twoje dane osobowe przetwarzane przez Administratora nie dłużej, niż
          jest to konieczne do wykonania związanych z nimi czynności określonych
          osobnymi przepisami (np. o prowadzeniu rachunkowości). W odniesieniu
          do danych marketingowych dane nie będą przetwarzane dłużej niż przez 3
          lata.
        </li>
        <li class="block_3">Przysługuje Ci prawo żądania od Administratora:</li>
      </ol>
      <ul class="list_1">
        <li class="block_4">dostępu do danych osobowych Ciebie dotyczących,</li>
        <li class="block_4">ich sprostowania,</li>
        <li class="block_4">usunięcia,</li>
        <li class="block_4">ograniczenia przetwarzania,</li>
        <li class="block_4">oraz przenoszenia danych.</li>
      </ul>
      <ol class="list_">
        <li value="4" class="block_3">
          Przysługuje Ci prawo do złożenia sprzeciwu w zakresie przetwarzania
          wskazanego w pkt 3.3 c) wobec przetwarzania danych osobowych w celu
          wykonania prawnie uzasadnionych interesów realizowanych przez
          Administratora, w tym profilowania, przy czym prawo sprzeciwu nie
          będzie mogło być wykonane w przypadku istnienia ważnych prawnie
          uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Ciebie
          interesów, praw i wolności, w szczególności ustalenia, dochodzenia lub
          obrony roszczeń.
        </li>
        <li class="block_3">
          Na działania Administratora przysługuje skarga do Prezesa Urzędu
          Ochrony Danych Osobowych, ul. Stawki 2, 00-193 Warszawa.
        </li>
        <li class="block_3">
          Podanie danych osobowych jest dobrowolne, lecz niezbędne do obsługi
          Serwisu.
        </li>
        <li class="block_3">
          W stosunku do Ciebie mogą być podejmowane czynności polegające na
          zautomatyzowanym podejmowaniu decyzji, w tym profilowaniu w celu
          świadczenia usług w ramach zawartej umowy oraz w celu prowadzenia
          przez Administratora marketingu bezpośredniego.
        </li>
        <li class="block_3">
          Dane osobowe nie są przekazywane od krajów trzecich w rozumieniu
          przepisów o ochronie danych osobowych. Oznacza to, że nie przesyłamy
          ich poza teren Unii Europejskiej.
        </li>
      </ol>
      <p class="block_2">
        <span class="text_">5. Informacje w formularzach</span>
      </p>
      <ol class="list_">
        <li class="block_3">
          Serwis zbiera informacje podane dobrowolnie przez użytkownika, w tym
          dane osobowe, o ile zostaną one podane.
        </li>
        <li class="block_3">
          Serwis może zapisać informacje o parametrach połączenia (oznaczenie
          czasu, adres IP).
        </li>
        <li class="block_3">
          Serwis, w niektórych wypadkach, może zapisać informację ułatwiającą
          powiązanie danych w formularzu z adresem e-mail użytkownika
          wypełniającego formularz. W takim wypadku adres e-mail użytkownika
          pojawia się wewnątrz adresu url strony zawierającej formularz.
        </li>
        <li class="block_3">
          Dane podane w formularzu są przetwarzane w celu wynikającym z funkcji
          konkretnego formularza, np. w celu dokonania procesu obsługi
          zgłoszenia serwisowego lub kontaktu handlowego, rejestracji usług itp.
          Każdorazowo kontekst i opis formularza w czytelny sposób informuje, do
          czego on służy.
        </li>
      </ol>
      <p class="block_2">
        <span class="text_">6. Logi Administratora</span>
      </p>
      <ol class="list_">
        <li class="block_3">
          Informacje zachowaniu użytkowników w serwisie mogą podlegać logowaniu.
          Dane te są wykorzystywane w celu administrowania serwisem.
        </li>
      </ol>
      <p class="block_2">
        <span class="text_">7. Istotne techniki marketingowe</span>
      </p>
      <ol class="list_">
        <li class="block_3">
          Operator stosuje analizę statystyczną ruchu na stronie, poprzez Google
          Analytics (Google Inc. z siedzibą w USA). Operator nie przekazuje do
          operatora tej usługi danych osobowych, a jedynie zanonimizowane
          informacje. Usługa bazuje na wykorzystaniu ciasteczek w urządzeniu
          końcowym użytkownika. W zakresie informacji o preferencjach
          użytkownika gromadzonych przez sieć reklamową Google użytkownik może
          przeglądać i edytować informacje wynikające z plików cookies przy
          pomocy narzędzia: https://www.google.com/ads/preferences/
        </li>
        <li class="block_3">
          Operator stosuje techniki remarketingowe, pozwalające na dopasowanie
          przekazów reklamowych do zachowania użytkownika na stronie, co może
          dawać złudzenie, że dane osobowe użytkownika są wykorzystywane do jego
          śledzenia, jednak w praktyce nie dochodzi do przekazania żadnych
          danych osobowych od Operatora do operatorom reklam. Technologicznym
          warunkiem takich działań jest włączona obsługa plików cookie.
        </li>
        <li class="block_3">
          Operator stosuje korzysta z piksela Facebooka. Ta technologia
          powoduje, że serwis Facebook (Facebook Inc. z siedzibą w USA) wie, że
          dana osoba w nim zarejestrowana korzysta z Serwisu. Bazuje w tym
          wypadku na danych, wobec których sam jest administratorem, Operator
          nie przekazuje od siebie żadnych dodatkowych danych osobowych
          serwisowi Facebook. Usługa bazuje na wykorzystaniu ciasteczek w
          urządzeniu końcowym użytkownika.
        </li>
        <li class="block_3">
          Operator stosuje rozwiązanie automatyzujące działanie Serwisu w
          odniesieniu do użytkowników, np. mogące przesłać maila do użytkownika
          po odwiedzeniu konkretnej podstrony, o ile wyraził on zgodę na
          otrzymywanie korespondencji handlowej od Operatora.
        </li>
      </ol>
      <p class="block_2">
        <span class="text_">8. Informacja o plikach cookies</span>
      </p>
      <ol class="list_">
        <li class="block_3">Serwis korzysta z plików cookies.</li>
        <li class="block_3">
          Pliki cookies (tzw. „ciasteczka”) stanowią dane informatyczne, w
          szczególności pliki tekstowe, które przechowywane są w urządzeniu
          końcowym Użytkownika Serwisu i przeznaczone są do korzystania ze stron
          internetowych Serwisu. Cookies zazwyczaj zawierają nazwę strony
          internetowej, z której pochodzą, czas przechowywania ich na urządzeniu
          końcowym oraz unikalny numer.
        </li>
        <li class="block_3">
          Podmiotem zamieszczającym na urządzeniu końcowym Użytkownika Serwisu
          pliki cookies oraz uzyskującym do nich dostęp jest operator Serwisu.
        </li>
        <li class="block_3">
          Pliki cookies wykorzystywane są w następujących celach:
        </li>
      </ol>
      <ol class="list_">
        <li class="block_4">
          utrzymanie sesji użytkownika Serwisu (po zalogowaniu), dzięki której
          użytkownik nie musi na każdej podstronie Serwisu ponownie wpisywać
          loginu i hasła;
        </li>
        <li class="block_4">
          realizacji celów określonych powyżej w części "Istotne techniki
          marketingowe";
        </li>
      </ol>
      <ol class="list_">
        <li value="5" class="block_3">
          W ramach Serwisu stosowane są dwa zasadnicze rodzaje plików cookies:
          „sesyjne” (session cookies) oraz „stałe” (persistent cookies). Cookies
          „sesyjne” są plikami tymczasowymi, które przechowywane są w urządzeniu
          końcowym Użytkownika do czasu wylogowania, opuszczenia strony
          internetowej lub wyłączenia oprogramowania (przeglądarki
          internetowej). „Stałe” pliki cookies przechowywane są w urządzeniu
          końcowym Użytkownika przez czas określony w parametrach plików cookies
          lub do czasu ich usunięcia przez Użytkownika.
        </li>
        <li class="block_3">
          Oprogramowanie do przeglądania stron internetowych (przeglądarka
          internetowa) zazwyczaj domyślnie dopuszcza przechowywanie plików
          cookies w urządzeniu końcowym Użytkownika. Użytkownicy Serwisu mogą
          dokonać zmiany ustawień w tym zakresie.&nbsp;Przeglądarka internetowa
          umożliwia usunięcie plików cookies. Możliwe jest także automatyczne
          blokowanie plików cookies Szczegółowe informacje na ten temat zawiera
          pomoc lub dokumentacja przeglądarki internetowej.
        </li>
        <li class="block_3">
          Ograniczenia stosowania plików cookies mogą wpłynąć na niektóre
          funkcjonalności dostępne na stronach internetowych Serwisu.
        </li>
        <li class="block_3">
          Pliki cookies zamieszczane w urządzeniu końcowym Użytkownika Serwisu
          wykorzystywane mogą być również przez współpracujące z operatorem
          Serwisu podmioty, w szczególności dotyczy to firm: Google (Google Inc.
          z siedzibą w USA), Facebook (Facebook Inc. z siedzibą w USA), Twitter
          (Twitter Inc. z siedzibą w USA).
        </li>
      </ol>
      <p class="block_2">
        <span class="text_">
          9. Zarządzanie plikami cookies &ndash; jak w praktyce wyrażać i cofać
          zgodę?
        </span>
      </p>
      <ol class="list_">
        <li class="block_3">
          Jeśli użytkownik nie chce otrzymywać plików cookies, może zmienić
          ustawienia przeglądarki. Zastrzegamy, że wyłączenie obsługi plików
          cookies niezbędnych dla procesów uwierzytelniania, bezpieczeństwa,
          utrzymania preferencji użytkownika może utrudnić,&nbsp;a w skrajnych
          przypadkach może uniemożliwić korzystanie ze stron www
        </li>
        <li class="block_3">
          W celu zarządzania ustawienia cookies wybierz z listy poniżej
          przeglądarkę internetową, której używasz i postępuj zgodnie z
          instrukcjami:
        </li>
      </ol>
      <ul class="list_1">
        <li class="block_4">
          <a
            href="https://support.microsoft.com/pl-pl/help/10607/microsoft-edge-view-delete-browser-history"
            class="text_2"
          >
            Edge
          </a>
        </li>
        <li class="block_4">
          <a
            href="https://support.microsoft.com/pl-pl/help/278835/how-to-delete-cookie-files-in-internet-explorer"
            class="text_2"
          >
            Internet Explorer
          </a>
        </li>
        <li class="block_4">
          <a
            href="http://support.google.com/chrome/bin/answer.py?hl=pl&amp;answer=95647"
            class="text_2"
          >
            Chrome
          </a>
        </li>
        <li class="block_4">
          <a href="http://support.apple.com/kb/PH5042" class="text_2">
            Safari
          </a>
        </li>
        <li class="block_4">
          <a
            href="http://support.mozilla.org/pl/kb/W%C5%82%C4%85czanie%20i%20wy%C5%82%C4%85czanie%20obs%C5%82ugi%20ciasteczek"
            class="text_2"
          >
            Firefox
          </a>
        </li>
        <li class="block_4">
          <a
            href="http://help.opera.com/Windows/12.10/pl/cookies.html"
            class="text_2"
          >
            Opera
          </a>
        </li>
      </ul>
      <p class="block_5">Urządzenia mobilne:</p>
      <ul class="list_1">
        <li class="block_4">
          <a
            href="http://support.google.com/chrome/bin/answer.py?hl=pl&amp;answer=95647"
            class="text_2"
          >
            Android
          </a>
        </li>
        <li class="block_4">
          <a
            href="http://support.apple.com/kb/HT1677?viewlocale=pl_PL"
            class="text_2"
          >
            Safari (iOS)
          </a>
        </li>
        <li class="block_4">
          <a
            href="http://www.windowsphone.com/pl-pl/how-to/wp7/web/changing-privacy-and-other-browser-settings"
            class="text_2"
          >
            Windows Phone
          </a>
        </li>
      </ul>
      <p class="block_6">
        Niniejszy wzór polityki został wygenerowany bezpłatnie, w celach
        informacyjnych, w oparciu o naszą wiedzę, branżowe praktyki i przepisy
        prawa obowiązujące na dzień 2018-08-14. Zalecamy sprawdzenie wzoru
        polityki przed użyciem jej na stronie. Wzór opiera się na najczęściej
        występujących na stronach internetowych sytuacjach, ale może nie
        odzwierciedlać pełnej i dokładnej specyfiki Twojej strony www.
        Przeczytaj uważnie wygenerowany dokument i w razie potrzeb dostosuj go
        do Twojej sytuacji lub zasięgnij porady prawnej. Nie bierzemy
        odpowiedzianości za skutki posługiwania się tym dokumentem, ponieważ
        tylko Ty masz wpłw na to, czy wszystkie informacje w nim zawarte są
        zgodne z prawdą. Zwróć także uwagę, że Polityka Prywatności, nawet
        najlepsza, jest tylko jednym z ekmentów Twojej troski o dane osobowe i
        prywatność użytkownika na stronie www.
      </p>
      <p class="block_7">&nbsp;</p>
    </div>
  )
}

export default Index
